module.exports = __webpack_public_path__ + "assets/img/Nexon-2-Landing-Page-w720.9cdf37c6.webp";